import {
    addDays,
    differenceInCalendarWeeks,
    differenceInCalendarYears,
    getDate,
    getMonth,
    getYear,
    isThisWeek,
    isThisYear,
    isToday,
    isYesterday,
} from 'date-fns';

enum EDividerPeriod {
    today = 'Сегодня',
    yesterday = 'Вчера',
    thisWeek = 'Ранее на этой неделе',
    pastWeek = 'На прошлой неделе',
}

const MONTH = {
    0: 'Январь',
    1: 'Февраль',
    2: 'Март',
    3: 'Апрель',
    4: 'Май',
    5: 'Июнь',
    6: 'Июль',
    7: 'Август',
    8: 'Сентябрь',
    9: 'Октябрь',
    10: 'Ноябрь',
    11: 'Декабрь',
};

const MONTH_WITH_DAY = {
    0: 'Января',
    1: 'Февраля',
    2: 'Марта',
    3: 'Апреля',
    4: 'Мая',
    5: 'Июня',
    6: 'Июля',
    7: 'Августа',
    8: 'Сентября',
    9: 'Октября',
    10: 'Ноября',
    11: 'Декабря',
};

export const getPeriodNameByDate = (date: number) => {
    const now = Date.now();

    const pastWeek = differenceInCalendarWeeks(now, date, { weekStartsOn: 1 }) === 1;
    const pastYear = differenceInCalendarYears(now, date) === 1;

    if (isToday(date)) {
        return 'today';
    } else if (isYesterday(date)) {
        return 'yesterday';
    } else if (isThisWeek(date, { weekStartsOn: 1 })) {
        return 'thisWeek';
    } else if (pastWeek) {
        return 'pastWeek';
    } else if (isThisYear(date)) {
        return `month-${getMonth(date)}`;
    } else if (pastYear) {
        return `month-${getMonth(date)}-year-${getYear(date)}`;
    }

    return `year-${getYear(date)}`;
};

export const getDividerPeriodName = (period: string) => {
    const name = EDividerPeriod[period];

    if (name) {
        return name;
    }

    const month = period.match(/month-(\d*)-?/)?.[1];
    const year = period.match(/year-(\d*)-?/)?.[1];

    return `${month ? MONTH[month] : ''}${month && year ? ' ' : ''}${year ?? ''}`;
};

export const isWholeYear = (startDate: number, endDate: number): boolean => {
    const start = new Date(startDate);
    const end = addDays(new Date(endDate), -1);
    const startYear = getYear(start);
    const startMonthIndex = getMonth(start);
    const endYear = getYear(end);
    const endMonthIndex = getMonth(end);

    return startMonthIndex === 0 && getDate(start) === 1 && endMonthIndex === 11 && getDate(end) === 31 && startYear === endYear;
};

export const getAnchorNameByPeriod = (startDate: number, endDate: number): string => {
    const start = new Date(startDate);
    const endReal = new Date(endDate);
    const end = addDays(new Date(endDate), -1);

    const today = new Date();
    const currentYear = getYear(today);

    const startYear = getYear(start);
    const startMonthIndex = getMonth(start);
    const startMonth = MONTH[startMonthIndex];
    const startMonthWithDay = MONTH_WITH_DAY[startMonthIndex];

    const endYear = getYear(end);
    const endMonthIndex = getMonth(end);
    const endMonth = MONTH[endMonthIndex];

    const totalDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));

    if (totalDays === 1) {
        const showYear = startYear !== currentYear;
        return showYear
            ? `${getDate(start)} ${startMonthWithDay.toLowerCase()} ${startYear}`
            : `${getDate(start)} ${startMonthWithDay.toLowerCase()}`;
    }

    if (isWholeYear(startDate, endDate)) {
        return `${startYear}`;
    }

    if (getDate(start) === 1 && getDate(endReal) === 1 && startYear === endYear && startMonthIndex === endMonthIndex) {
        return `${startMonth} ${startYear}`;
    }

    if (startYear === endYear) {
        return `${startMonth} – ${endMonth} ${startYear}`;
    }

    return `${startMonth} ${startYear} – ${endMonth} ${endYear}`;
};
